import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { getStripeAccountInfo } from '../../../api/system';
import { useSystemStore } from '../../../store/systemStore';

const useStripeAccountInfo = (
  systemId?: string | null,
  options?: Omit<UseQueryOptions, 'queryKey' | 'queryFn'>
) => {
  return useQuery({
    queryKey: ['stripeAccountInfo', useSystemStore.getState().systemInfo.gid],
    queryFn: () => getStripeAccountInfo(systemId),
    ...options,
  });
};

export default useStripeAccountInfo;
